module.exports = __webpack_public_path__ + "img/logo-esto.133575cb.png";